import { AxiosResponse } from "axios";
import Api from "../api";
import { PaginationResponse, StatusResponse } from "../../types/type";
import { assetFamilyMaster, CountryMaster, CurrencyMaster, StockCodeMaster, ManufacturerMaster, ownerAssetMaster, RolesMaster, TechniqueMaster, UserMaster, LocalStoreMaster, UnitMaster, ServiceTemplateMaster, TemplateMasterList, TemplateMasterKey, columnsTemplateCheckList, FaultAssetMapMaster, InspectionMasterList, InspectionTemplateMaster, InspectionTemplateMasterKey, InspectionAssetMapMaster, columnsInspectionCheckList, InspectionColumnDataPayload, ServiceColumnDataPayload, RegionMaster, StatusMaster, TransportMaster, ProjectMaster, FormValues, TemplateColumnMaster, InspectionColumnMaster, ToolsMaster, EquipmentMaster, DataHistory, HistoryLog, Entry, CodeTypeMaster, ClassCodeMaster, ModelType, Region, CostAllocationType, TransporterMaster, SupplierMaster, StockCode, StockTransaction, CategoryMaster, ServiceTypeType, InspectionTypeType, BackchargeMaster } from "../../types/assetTypes";
import { ASSET_OWNER, COUNTRY_MASTER, FAMILY_MASTER, CURRENCY_MASTER, MANUFACTURER_MASTER, ROLES_MASTER, TRANSPORT_MASTER, STOCKCODE_MASTER, TECHNIQUE_MASTER, USER_MASTER, LOCALSTORE_MASTER, UNITS_MASTER, DELETE_BY_ID_USER, DELETE_BY_ID_COUNTRY, DELETE_BY_ID_FAMILY, DELETE_BY_ID_MANUFACTURER, DELETE_BY_ID_OWNER, DELETE_BY_ID_TECHNIQUE, DELETE_BY_ID_CURRENCY, DELETE_BY_ID_STOCKCODE, SERVICE_TEMPLATE, SERVICE_TEMPLATE_MASTER, GET_LIST_TEMPLATE_BY_ASSET_ID, SERVICEMAP_TEMPLATE, INSPECTION_TEMPLATE, INSPECTION_TEMPLATE_MASTER, GET_LIST_INSPECTIONTEMPLATE_BY_ASSET_ID, INSPECTIONMAP_TEMPLATE, INSPECTION_TEMPLATE_COLUMN, SERVICE_TEMPLATE_COLUMN, REGION_MASTER, STATUS_MASTER, TEMPLATECOLUMN_MASTER, PROJECT_MASTER, LOGISTICS_MASTER, INSPECTIONCOLUMN_MASTER, TOOLS_MASTER, EQUIPMENT_MASTER, HISTORY, NOTICE_MASTER, NOTICE, CREATE_INDENT, FAMILYTOOLS_MASTER, FAMILYEQUIPEMENT_MASTER, CODETYPE_MASTER, CLASSCODE_MASTER, MODEL_MASTER, COSTALLOCATION_MASTER, TRANSPORTER_MASTER, SUPPLIER_MASTER, STOCK_DETAILS, STOCK_TRANS, CATEGORY_MASTER, SERVICETYPE_MASTER, INSPECTIONTYPE_MASTER, CREATE_INDENTTEMPLATE, TIMESHEET_MASTER, USERPASSRESET_MASTER, BACKCHARGE_MASTER} from "../endpoint";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";

type FilterValue = {
 
    value: string[];
  };
  
  type Filters = {
    [key: string]: FilterValue;
  };

  interface Project {
  projectId: number;
  projectName: string;
}

interface RegionProjectResponse {
  regionId: number;
  regionName: string;
  projects: Project[];
}
interface ServiceColumnMap {
    familyAssetId: number;
    assetName: string[]; // multiple asset names
}

export const getServiceTemplateList = async (
    payload: ServiceColumnMap
): Promise<{ status: StatusResponse; data: TemplateMasterList[] }> => {
    const config = {
        method: 'post',            
        url: SERVICE_TEMPLATE_MASTER,
        data: payload,             
    };

    try {
        const response: AxiosResponse<{
            status: StatusResponse;
            data: TemplateMasterList[];
        }> = await Api(config);

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error(`Request failed with status code: ${response.status}`);
        }
    } catch (error) {
        throw error;
    }
};


export const getInspectionTemplateList = async (
  payload: ServiceColumnMap
): Promise<{ status: StatusResponse; data: InspectionMasterList[] }> => {
  const config = {
    method: "post",
    url: INSPECTION_TEMPLATE_MASTER,
    data: payload,
  };

  try {
    const response: AxiosResponse<{
      status: StatusResponse;
      data: InspectionMasterList[];
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};



export const getTemplateDataList = async (familyAssetId: number): Promise<{
    status: StatusResponse, 
    data: TemplateMasterKey[]
}> => {
    const config = {
        method: 'get',
        url: GET_LIST_TEMPLATE_BY_ASSET_ID + familyAssetId,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: TemplateMasterKey[]
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getTemplateDataById = async (serviceTemplateId: number): Promise<{
    status: StatusResponse, 
    data: {
        serviceTemplateId : number;
        serviceTemplateName : string;
        familyAssetId : number;
        familyName : string;
        columns: columnsTemplateCheckList[];
    } | null
}> => {
    const config = {
        method: 'get',
        url: SERVICE_TEMPLATE + '/' +  serviceTemplateId,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: {
                serviceTemplateId : number;
                serviceTemplateName : string;
                familyAssetId : number;
                familyName : string;
                columns: columnsTemplateCheckList[];
            } | null
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getFamilyAssetMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: assetFamilyMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,

            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: assetFamilyMaster[],
            pagination: PaginationResponse
        }> = await Api.post(`${FAMILY_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getTemplateList = async (): Promise<{ status: StatusResponse, data: TemplateMasterList[] }> => {
    const config = {
        method: 'get',
        url: SERVICE_TEMPLATE_MASTER,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: TemplateMasterList[]
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
};

export const saveServiceTemplate = async (payload:ServiceTemplateMaster):Promise<{ status: StatusResponse, data: any}> => {
    const config = {
        method: payload.serviceTemplateId === 0 ? 'post' : 'put',
        url: SERVICE_TEMPLATE,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
};

export const saveAssetFamily = async (payload:assetFamilyMaster):Promise<{
        status: StatusResponse,
        data: assetFamilyMaster
    }>  => {
    const config = {
        method: payload.familyAssetId === 0 ? 'post' : 'put',
        url: FAMILY_MASTER,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: assetFamilyMaster
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getAssetFamilyById = async (familyId:number):Promise<
    {
        status: StatusResponse, 
        data: assetFamilyMaster
    }> => {
    const config = {
        method: 'get',
        url: `${FAMILY_MASTER}/${familyId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: assetFamilyMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getOwnerAssetMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: ownerAssetMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ownerAssetMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${ASSET_OWNER}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${ASSET_OWNER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getListRoles = async(page:number, rows:number):Promise<{
    status: StatusResponse,
    data: RolesMaster[],
    pagination: PaginationResponse
}> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: RolesMaster[],
            pagination: PaginationResponse
        }> = await Api.get(`${ROLES_MASTER}?page=${page}&limit=${rows}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getAssetOwnerById = async (ownerId:number):Promise<
    {
        status: StatusResponse, 
        data: ownerAssetMaster
    }> => {
    const config = {
        method: 'get',
        url: `${ASSET_OWNER}/${ownerId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ownerAssetMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetOwner = async (payload:ownerAssetMaster):Promise<{
        status: StatusResponse,
        data: ownerAssetMaster
    }>  => {
    const config = {
        method: payload.assetOwnerId === 0 ? 'post' : 'put',
        url: ASSET_OWNER,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ownerAssetMaster
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetTechnique = async (payload:TechniqueMaster):Promise<{
        status: StatusResponse,
        data: TechniqueMaster
    }>  => {
    const config = {
        method: payload.techniqueId === 0 ? 'post' : 'put',
        url: TECHNIQUE_MASTER,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: TechniqueMaster
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

//save user






export const getTechniqueAssetMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: TechniqueMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: TechniqueMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${TECHNIQUE_MASTER}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${TECHNIQUE_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getAssetTechniqueById = async (techniqueId:number):Promise<
    {
        status: StatusResponse, 
        data: TechniqueMaster
    }> => {
    const config = {
        method: 'get',
        url: `${TECHNIQUE_MASTER}/${techniqueId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: TechniqueMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetCountry = async (payload:CountryMaster):Promise<{
        status: StatusResponse,
        data: CountryMaster
    }>  => {
    const config = {
        method: payload.currentLocationId === 0 ? 'post' : 'put',
        url: COUNTRY_MASTER,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CountryMaster
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getCountryAssetMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: CountryMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CountryMaster[],
            pagination: PaginationResponse
        // }> = await Api.get(`${COUNTRY_MASTER}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${COUNTRY_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getAssetCountryById = async (countryId:number):Promise<
    {
        status: StatusResponse, 
        data: CountryMaster
    }> => {
    const config = {
        method: 'get',
        url: `${COUNTRY_MASTER}/${countryId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CountryMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetManufacturer = async (payload:ManufacturerMaster):Promise<{
        status: StatusResponse,
        data: ManufacturerMaster
    }>  => {
    const config = {
        method: payload.manufacturerId === 0 ? 'post' : 'put',
        url: MANUFACTURER_MASTER,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ManufacturerMaster
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getManufacturerAssetMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: ManufacturerMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ManufacturerMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${MANUFACTURER_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${MANUFACTURER_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getAssetManufacturerById = async (countryId:number):Promise<
    {
        status: StatusResponse, 
        data: ManufacturerMaster
    }> => {
    const config = {
        method: 'get',
        url: `${MANUFACTURER_MASTER}/${countryId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ManufacturerMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


//users 

export const saveUsers = async (payload:UserMaster):Promise<{
    status: StatusResponse,
    data: UserMaster
}>  => {
const config = {
    method: payload.user_id === 0 ? 'post' : 'put',
    url: USER_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: UserMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getUsersById = async (user_id:number):Promise<
    {
        status: StatusResponse, 
        data: UserMaster
    }> => {
    const config = {
        method: 'get',
        url: `${USER_MASTER}/${user_id}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: UserMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const resetPassword = async (user_id:number):Promise<
    {
        status: StatusResponse, 
        data: UserMaster
    }> => {
    const config = {
        method: 'get',
        url: `${USERPASSRESET_MASTER}/${user_id}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: UserMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getUsersMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: UserMaster[],
        pagination: PaginationResponse,
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: UserMaster[],
            pagination: PaginationResponse
        }> = await Api.post(`${USER_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

// insurance currency
export const getAssetInsuranceCurrencyById = async (insuranceCurrencyId:number):Promise<
    {
        status: StatusResponse, 
        data: CurrencyMaster
    }> => {
    const config = {
        method: 'get',
        url: `${CURRENCY_MASTER}/${insuranceCurrencyId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CurrencyMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getCurrencyAssetMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: CurrencyMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
        limit: rows,
        page: page, offSet: page,
       
        filters: filter
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CurrencyMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${CURRENCY_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${CURRENCY_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetCurrency = async (payload:CurrencyMaster):Promise<{
    status: StatusResponse,
    data: CurrencyMaster
}>  => {
const config = {
    method: payload.insuranceCurrencyId === 0 ? 'post' : 'put',
    url: CURRENCY_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: CurrencyMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}



export const getStockCodeById = async (stockCodeId:number):Promise<
    {
        status: StatusResponse, 
        data: StockCodeMaster
    }> => {
    const config = {
        method: 'get',
        url: `${STOCKCODE_MASTER}/${stockCodeId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: StockCodeMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getStockCodeeById = async (stockCodeId:number):Promise<
    {
        status: StatusResponse, 
        data: StockCode
    }> => {
    const config = {
        method: 'get',
        url: `${STOCKCODE_MASTER}/${stockCodeId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: StockCode
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getStockCodeMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: StockCodeMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
          
            filters: filter
        }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: StockCodeMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${STOCKCODE_MASTER}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${STOCKCODE_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveStockCodee = async (payload:StockCode):Promise<{
    status: StatusResponse,
    data: StockCode
}>  => {
const config = {
    method: payload.stockCodeId === 0 ? 'post' : 'put',
    url: STOCKCODE_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: StockCode
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


export const saveStockCode = async (payload:StockCodeMaster):Promise<{
    status: StatusResponse,
    data: StockCodeMaster
}>  => {
const config = {
    method: payload.stockCodeId === 0 ? 'post' : 'put',
    url: STOCKCODE_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: StockCodeMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


export const saveStockTransaction = async (
  payload: StockTransaction
): Promise<{
  status: StatusResponse;
  data: any;
}> => {
  const config = {
    method: "post",
    url: STOCK_TRANS,
    data: payload,
  };

  try {
    const response: AxiosResponse<{
      status: StatusResponse;
      data: any;
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};



export const getLocalStoreById = async (localStoreId:number):Promise<
    {
        status: StatusResponse, 
        data: LocalStoreMaster
    }> => {
    const config = {
        method: 'get',
        url: `${LOCALSTORE_MASTER}/${localStoreId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: LocalStoreMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getLocalStoreByCountryId = async (currentLocationId:number):Promise<
    {
        status: StatusResponse, 
        data: LocalStoreMaster
    }> => {
    const config = {
        method: 'get',
        url: `${LOCALSTORE_MASTER}/country/${currentLocationId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: LocalStoreMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getRegionByCountryId = async (currentLocationId:number):Promise<
    {
        status: StatusResponse, 
        data: RegionMaster
    }> => {
    const config = {
        method: 'get',
        url: `${COUNTRY_MASTER}/region/${currentLocationId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: RegionMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getUsersByCountryId = async (currentLocationId:number):Promise<
    {
        status: StatusResponse, 
        data: any
    }> => {
    const config = {
        method: 'get',
        url: `${USER_MASTER}/country/${currentLocationId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getProjectByRegionId = async (regionId:number):Promise<
    {
        status: StatusResponse, 
        data: Region
    }> => {
    const config = {
        method: 'get',
        url: `${REGION_MASTER}/project/${regionId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: Region
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getCountryByProjectId = async (projectId:number):Promise<
    {
        status: StatusResponse, 
        data: CountryMaster
    }> => {
    const config = {
        method: 'get',
        url: `${COUNTRY_MASTER}/project/${projectId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CountryMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getModelByManufacturerId = async (manufacturerId:number):Promise<
    {
        status: StatusResponse, 
        data: ModelType[]
    }> => {
    const config = {
        method: 'get',
        url: `${MANUFACTURER_MASTER}/model/${manufacturerId}`

    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ModelType[]
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}







export const getLocalStoreMasterDataList = 
    async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: LocalStoreMaster[],  // ✅ Update the type here
        pagination: PaginationResponse
    }> => {
        const payload = {
            limit: rows,
            page: page, offSet: page,
          
            filters: filter
        }
    try {
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: LocalStoreMaster[],  // ✅ Update here too
            pagination: PaginationResponse
        //}> = await Api.get(`${LOCALSTORE_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${LOCALSTORE_MASTER}/filter`,payload);

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Request failed with status code: ${response.status}`);
        }
    } catch (error) {
        throw error;
    }
};


export const saveLocalStore = async (payload:LocalStoreMaster):Promise<{
    status: StatusResponse,
    data: LocalStoreMaster
}>  => {
const config = {
    method: payload.localStoreId === 0 ? 'post' : 'put',
    url: LOCALSTORE_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: LocalStoreMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//units

export const getUnitsById = async (unitId:number):Promise<
    {
        status: StatusResponse, 
        data: UnitMaster
    }> => {
    const config = {
        method: 'get',
        url: `${UNITS_MASTER}/${unitId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: UnitMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getUnitsMasterDataList = 
    async(page:number, rows:number):Promise<{
        status: StatusResponse,
        data: UnitMaster[],
        pagination: PaginationResponse
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: [],
            pagination: PaginationResponse
        }> = await Api.get(`${UNITS_MASTER}?page=${page}&limit=${rows}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveUnits = async (payload:UnitMaster):Promise<{
    status: StatusResponse,
    data: UnitMaster
}>  => {
const config = {
    method: payload.unitId === 0 ? 'post' : 'put',
    url: UNITS_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: UnitMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//delete 

export const deleteUsers = async (user_id:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_USER}/${user_id}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of user with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteOwner = async (assetOwnerId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_OWNER}/${assetOwnerId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of owner with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}



export const deleteFamily = async (familyAssetId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_FAMILY}/${familyAssetId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of family with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteManufacturer = async (manufacturerId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_MANUFACTURER}/${manufacturerId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of manufacturer with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteTechnique = async (techniqueId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_TECHNIQUE}/${techniqueId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of technique with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteCountry = async (currentLocationId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_COUNTRY}/${currentLocationId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of country status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteCurrency = async (insuranceCurrencyId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_CURRENCY}/${insuranceCurrencyId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of family with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const deleteStockCode = async (stockCodeId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_STOCKCODE}/${stockCodeId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of family with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}



export const createServiceTemplate = async (payload:ServiceTemplateMaster) => {
    try{
        const response = await Api.post(SERVICE_TEMPLATE,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const updateServiceTemplate = async (payload:ServiceTemplateMaster) => {
    try{
        const response = await Api.put(SERVICE_TEMPLATE,payload);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Update Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}


export const getListOfServiceTemplate = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> => {
    try{
        const payload = {
            limit:rows,
            page: page,

              
            offset: page,
            filters: filter, 
            searchTerm: searchTerm,
        }
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: [],
            pagination: PaginationResponse
        }> = await Api.post(`${SERVICE_TEMPLATE}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getListOfSavedService = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
    status: StatusResponse, 
    data: [],
    pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${SERVICE_TEMPLATE}/report/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const getListOfSavedInspection = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
    status: StatusResponse, 
    data: [],
    pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${INSPECTION_TEMPLATE}/report/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const getServiceTemplateByIdData = async (serviceTemplateId:number): Promise<{
        status: StatusResponse, 
        data: any
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any,
        }> = await Api.get(`${SERVICE_TEMPLATE}/${serviceTemplateId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const deleteServiceTemplate = async (serviceTemplateId:number) => {
    try{
        const response = await Api.delete(`${SERVICE_TEMPLATE}/${serviceTemplateId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const saveServiceTemplateMapping = async (payload:FaultAssetMapMaster):Promise<{ status: StatusResponse, data: any}> => {
    const config = {
        method: payload.serviceAssetMapId === 0 ? 'post' : 'put',
        url: SERVICEMAP_TEMPLATE,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
};


export const getListOfServiceTemplateMap = async (page:number, rows: number,filter: Filters | undefined ,searchTerm: string = ""): Promise<{
    status: StatusResponse, 
    data: [],
    pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${SERVICE_TEMPLATE}/asset/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const getListOfInspectionTemplateMap = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
    status: StatusResponse, 
    data: [],
    pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${INSPECTION_TEMPLATE}/asset/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}





export const getListOfInspectionTemplate = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${INSPECTION_TEMPLATE}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}



export const saveInspectionTemplate = async (payload:InspectionTemplateMaster):Promise<{ status: StatusResponse, data: any}> => {
    const config = {
        method: payload.inspectionTemplateId === 0 ? 'post' : 'put',
        url: INSPECTION_TEMPLATE,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
};



export const getInspectionTemplateDataList = async (familyAssetId: number): Promise<{
    status: StatusResponse, 
    data: InspectionTemplateMasterKey[]
}> => {
    const config = {
        method: 'get',
        url: GET_LIST_INSPECTIONTEMPLATE_BY_ASSET_ID + familyAssetId,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: InspectionTemplateMasterKey[]
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveInspectionTemplateMapping = async (payload:InspectionAssetMapMaster):Promise<{ status: StatusResponse, data: any}> => {
    const config = {
        method: payload.inspectionAssetMapId === 0 ? 'post' : 'put',
        url: INSPECTIONMAP_TEMPLATE,
        data: payload
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
};


export const getInspectionTemplateDataById = async (inspectionTemplateId: number): Promise<{
    status: StatusResponse, 
    data: {
        inspectionTemplateId : number;
        inspectionTemplateName : string;
        familyAssetId : number;
        familyName : string;
        columns: columnsInspectionCheckList[];
    } | null
}> => {
    const config = {
        method: 'get',
        url: INSPECTION_TEMPLATE + '/' +  inspectionTemplateId,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: {
                inspectionTemplateId : number;
                inspectionTemplateName : string;
                familyAssetId : number;
                familyName : string;
                columns: columnsInspectionCheckList[];
            } | null
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getInspectionAssetMapById = async (inspectionAssetMapId:number):Promise<
    {
        status: StatusResponse, 
        data: InspectionAssetMapMaster
    }> => {
    const config = {
        method: 'get',
        url: `${INSPECTIONMAP_TEMPLATE}/${inspectionAssetMapId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: InspectionAssetMapMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getInspectionTemplateColumnDetails = async (
    inspectionReportingId: number, 
    inspectionTemplateId: number, 
    service: string
): Promise<{ status: StatusResponse, data: InspectionColumnDataPayload[] }> => {
    const config = {
        method: 'post',
        url: INSPECTION_TEMPLATE_COLUMN,
        data: { // Sending data in request body
            inspectionReportingId,
            inspectionTemplateId,
            service
        }
    };

    try {
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: InspectionColumnDataPayload[]
        }> = await Api(config);

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error(`Request failed with status code: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching inspection template column details:", error);
        throw error;
    }
};


export const getServiceTemplateColumnDetails = async (
    serviceReportingId: number, 
    serviceTemplateId: number, 
    service: string
): Promise<{ status: StatusResponse, data: ServiceColumnDataPayload[] }> => {
    const config = {
        method: 'post',
        url: SERVICE_TEMPLATE_COLUMN,
        data: { // Sending data in request body
            serviceReportingId,
            serviceTemplateId,
            service
        }
    };

    try {
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ServiceColumnDataPayload[]
        }> = await Api(config);

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error(`Request failed with status code: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching service template column details:", error);
        throw error;
    }
};



export const saveRegion = async (payload:RegionMaster):Promise<{
    status: StatusResponse,
    data: RegionMaster
}>  => {
const config = {
    method: payload.regionId === 0 ? 'post' : 'put',
    url: REGION_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: RegionMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//save user






export const getRegionMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: RegionMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: RegionMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${REGION_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${REGION_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getIndentsTemplateDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: any
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: any
        pagination: PaginationResponse
    //}> = await Api.get(`${REGION_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${CREATE_INDENTTEMPLATE}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getRegionById = async (regionId:number):Promise<
{
    status: StatusResponse, 
    data: RegionMaster
}> => {
const config = {
    method: 'get',
    url: `${REGION_MASTER}/${regionId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: RegionMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}



export const saveStatus = async (payload:StatusMaster):Promise<{
    status: StatusResponse,
    data: StatusMaster
}>  => {
const config = {
    method: payload.statusId === 0 ? 'post' : 'put',
    url: STATUS_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: StatusMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//save user






export const getStatusMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: StatusMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: StatusMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${STATUS_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${STATUS_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getStatusById = async (statusId:number):Promise<
{
    status: StatusResponse, 
    data: StatusMaster
}> => {
const config = {
    method: 'get',
    url: `${STATUS_MASTER}/${statusId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: StatusMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//transport 

export const saveTransport = async (payload:TransportMaster):Promise<{
    status: StatusResponse,
    data: TransportMaster
}>  => {
const config = {
    method: payload.transportId === 0 ? 'post' : 'put',
    url: TRANSPORT_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransportMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//save user






export const getTransportMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: TransportMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransportMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${TRANSPORT_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${TRANSPORT_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getTransportById = async (transportId:number):Promise<
{
    status: StatusResponse, 
    data: TransportMaster
}> => {
const config = {
    method: 'get',
    url: `${TRANSPORT_MASTER}/${transportId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransportMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//project


export const saveProject = async (payload:ProjectMaster):Promise<{
    status: StatusResponse,
    data: ProjectMaster
}>  => {
const config = {
    method: payload.projectId === 0 ? 'post' : 'put',
    url: PROJECT_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ProjectMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//save user






export const getProjectMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: ProjectMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ProjectMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${PROJECT_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${PROJECT_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getProjectById = async (projectId:number):Promise<
{
    status: StatusResponse, 
    data: ProjectMaster
}> => {
const config = {
    method: 'get',
    url: `${PROJECT_MASTER}/${projectId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ProjectMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const saveLogistics = async (payload:FormValues):Promise<{
    status: StatusResponse,
    data: FormValues
}>  => {
const config = {
    method: payload.logisticsId === 0 ? 'post' : 'put',
    url: LOGISTICS_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: FormValues
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//template columns 

export const saveTemplateColumn = async (payload:TemplateColumnMaster):Promise<{
    status: StatusResponse,
    data: TemplateColumnMaster
}>  => {
const config = {
    method: payload.templateColumnId === 0 ? 'post' : 'put',
    url: TEMPLATECOLUMN_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TemplateColumnMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//
export const createTimeSheet = async (payload: any): Promise<{
  status: StatusResponse;
  data: any[];
}> => {
  const config = {
    method: payload.timeSheetId === 0 ? "post" : "put",
    url: TIMESHEET_MASTER,
    data: payload,
  };

  try {
    const response: AxiosResponse<{
      status: StatusResponse;
      data: any[];
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};




export const getTemplateColumnMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: TemplateColumnMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TemplateColumnMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${TEMPLATECOLUMN_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${TEMPLATECOLUMN_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getTemplateColumnById = async (templateColumnId:number):Promise<
{
    status: StatusResponse, 
    data: TemplateColumnMaster
}> => {
const config = {
    method: 'get',
    url: `${TEMPLATECOLUMN_MASTER}/${templateColumnId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TemplateColumnMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

//inspection Columns 


export const saveInspectionColumn = async (payload:InspectionColumnMaster):Promise<{
    status: StatusResponse,
    data: InspectionColumnMaster
}>  => {
const config = {
    method: payload.inspectionColumnId === 0 ? 'post' : 'put',
    url: INSPECTIONCOLUMN_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: InspectionColumnMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}



export const getInspectionColumnMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: InspectionColumnMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: InspectionColumnMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${INSPECTIONCOLUMN_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${INSPECTIONCOLUMN_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getInspectionColumnById = async (inspectionColumnId:number):Promise<
{
    status: StatusResponse, 
    data: InspectionColumnMaster
}> => {
const config = {
    method: 'get',
    url: `${INSPECTIONCOLUMN_MASTER}/${inspectionColumnId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: InspectionColumnMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


//tools 

export const saveTools = async (payload:ToolsMaster):Promise<{
    status: StatusResponse,
    data: ToolsMaster
}>  => {
const config = {
    method: payload.toolsId === 0 ? 'post' : 'put',
    url: TOOLS_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ToolsMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getToolsMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: ToolsMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ToolsMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${TOOLSMASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${TOOLS_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getToolsById = async (toolsId:number):Promise<
{
    status: StatusResponse, 
    data: ToolsMaster
}> => {
const config = {
    method: 'get',
    url: `${TOOLS_MASTER}/${toolsId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ToolsMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getToolsByFamilyId = async (familyAssetId:number):Promise<
{
    status: StatusResponse, 
    data: ToolsMaster
}> => {
const config = {
    method: 'get',
    url: `${FAMILYTOOLS_MASTER}/${familyAssetId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: ToolsMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getEquipmentsByFamilyId = async (familyAssetId:number):Promise<
{
    status: StatusResponse, 
    data: EquipmentMaster
}> => {
const config = {
    method: 'get',
    url: `${FAMILYEQUIPEMENT_MASTER}/${familyAssetId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: EquipmentMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


//tools 

export const saveEquipment = async (payload:EquipmentMaster):Promise<{
    status: StatusResponse,
    data: EquipmentMaster
}>  => {
const config = {
    method: payload.equipmentId === 0 ? 'post' : 'put',
    url: EQUIPMENT_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: EquipmentMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
        
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
     
}catch(error){
    throw error;
}
}

export const getEquipmentMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: EquipmentMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: EquipmentMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${TOOLSMASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${EQUIPMENT_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getEquipmentById = async (equipmentId:number):Promise<
{
    status: StatusResponse, 
    data: EquipmentMaster
}> => {
const config = {
    method: 'get',
    url: `${EQUIPMENT_MASTER}/${equipmentId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: EquipmentMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}
export const getAllUsersHistory = async (): Promise<{
    status: StatusResponse;
    data: DataHistory; // 👈 instead of HistoryLog[]
  }> => {
    const config = {
      method: 'get',
      url: HISTORY,
    };
  
    try {
      const response: AxiosResponse<{
        status: StatusResponse;
        data: DataHistory;
      }> = await Api(config);
  
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code:${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };


//save latest


export const saveInfo = async (payload:Entry):Promise<{
    status: StatusResponse,
    data: Entry
}>  => {
const config = {
    method: payload.noticeId === 0 ? 'post' : 'put',
    url: NOTICE_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: Entry
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getAllNotice = async (): Promise<{
    status: StatusResponse;
    data:  {
        noticeId: number;
        info: string;
        createdAt: string;
        userId: number;
        userName: string;
        currentLocationId: number | null;
        countryName: string | null;
    }[];
  }> => {
    const config = {
      method: 'get',
      url: NOTICE,
    };
  
    try {
      const response: AxiosResponse<{
        status: StatusResponse;
        data: {
            noticeId: number;
            info: string;
            createdAt: string;
            userId: number;
            userName: string;
            currentLocationId: number | null;
            countryName: string | null;
        }[];
      }> = await Api(config);
  
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code:${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

  export const getAllNoticeByCountry = async (currentLocationId: number): Promise<{
    status: StatusResponse;
    data: {
      noticeId: number;
      info: string;
      createdAt: string;
      userId: number;
      userName: string;
      currentLocationId: number | null;
      countryName: string | null;
    }[];
  }> => {
    try {
      const response = await Api.get(`${NOTICE}/country/${currentLocationId}`);
      
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };
  


  export const getListOfIndents = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
    status: StatusResponse, 
    data: [],
    pagination: PaginationResponse
}> => {
try{
    const payload = {
        limit:rows,
        offset: page,
        page: page,
        filters: filter, 
        searchTerm: searchTerm,
    }
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> = await Api.post(`${CREATE_INDENT}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get list of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
};



export const getListOfIndentsWithProjects = async (
  page: number,
  rows: number,
  userId: number,
  projectIds: number[],
  filter?: Filters,
  searchTerm: string = ""
): Promise<{
  status: StatusResponse;
  data: any[];
  pagination: PaginationResponse;
}> => {
  try {
    const payload = {
      userId,
      projectIds,
      limit: rows,
      page,
      filters: filter,
      searchTerm,
    };

    const response: AxiosResponse<{
      status: StatusResponse;
      data: any[];
      pagination: PaginationResponse;
    }> = await Api.post(`${CREATE_INDENT}/projects`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error in Get List of Indents with status code: ${response.status}`);
    }
  } catch (err) {
    throw err;
  }
};

export const getListOfIndentsWithProjectsBending = async (
  page: number,
  rows: number,
  userId: number,
  projectIds: number[],
 
  filter?: Filters,  
  searchTerm: string = ""
): Promise<{
  status: StatusResponse;
  data: any[];
  pagination: PaginationResponse;
}> => {
  try {
    const payload = {
      userId,
      projectIds,
      limit: rows,
      page,
      filters: filter,
     
      searchTerm,
    };

    const response: AxiosResponse<{
      status: StatusResponse;
      data: any[];
      pagination: PaginationResponse;
    }> = await Api.post(`${CREATE_INDENT}/projects/statusBending`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error in Get List of Indents with status code: ${response.status}`);
    }
  } catch (err) {
    throw err;
  }
};

export const getListOfIndentsWithProjectsSubmitted = async (
  page: number,
  rows: number,
  userId: number,
  projectIds: number[],  
  filter?: Filters,
  status?: number,  
  searchTerm: string = ""
): Promise<{
  status: StatusResponse;
  data: any[];
  pagination: PaginationResponse;
}> => {
  try {
    const payload = {
      userId,
      projectIds,      
      limit: rows,
      page,
      filters: filter, 
      status,     
      searchTerm,
    };

    const response: AxiosResponse<{
      status: StatusResponse;
      data: any[];
      pagination: PaginationResponse;
    }> = await Api.post(`${CREATE_INDENT}/projects/statuss`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error in Get List of Indents with status code: ${response.status}`);
    }
  } catch (err) {
    throw err;
  }
};

export const getCodeTypeById = async (typeCodeId: number): Promise<{
  status: StatusResponse,
  data: CodeTypeMaster
}> => {
  const config = {
    method: 'get',
    url: `${CODETYPE_MASTER}/${typeCodeId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: CodeTypeMaster
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getCodeTypeMasterDataList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: CodeTypeMaster[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: CodeTypeMaster[],
        pagination: PaginationResponse
      }> = await Api.post(`${CODETYPE_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

export const saveCodeType = async (payload: CodeTypeMaster): Promise<{
  status: StatusResponse,
  data: CodeTypeMaster
}> => {
  const config = {
    method: payload.typeCodeId === 0 ? 'post' : 'put',
    url: CODETYPE_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: CodeTypeMaster
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getClassCodeById = async (classCodeId: number): Promise<{
  status: StatusResponse,
  data: ClassCodeMaster
}> => {
  const config = {
    method: 'get',
    url: `${CLASSCODE_MASTER}/${classCodeId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ClassCodeMaster
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getClassCodeMasterDataList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: ClassCodeMaster[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: ClassCodeMaster[],
        pagination: PaginationResponse
      }> = await Api.post(`${CLASSCODE_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

export const saveClassCode = async (payload: ClassCodeMaster): Promise<{
  status: StatusResponse,
  data: ClassCodeMaster
}> => {
  const config = {
    method: payload.classCodeId === 0 ? 'post' : 'put',
    url: CLASSCODE_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ClassCodeMaster
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};





export const getModelById = async (modelId: number): Promise<{
  status: StatusResponse,
  data: ModelType
}> => {
  const config = {
    method: 'get',
    url: `${MODEL_MASTER}/${modelId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ModelType
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getModelList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: ModelType[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: ModelType[],
        pagination: PaginationResponse
      }> = await Api.post(`${MODEL_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

export const saveModel = async (payload: ModelType): Promise<{
  status: StatusResponse,
  data: ModelType
}> => {
  const config = {
    method: payload.modelId === 0 ? 'post' : 'put',
    url: MODEL_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ModelType
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


export const getCostAllocationById = async (costallocationId: number): Promise<{
  status: StatusResponse,
  data: CostAllocationType
}> => {
  const config = {
    method: 'get',
    url: `${COSTALLOCATION_MASTER}/${costallocationId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: CostAllocationType
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getCostAllocationList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: CostAllocationType[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: CostAllocationType[],
        pagination: PaginationResponse
      }> = await Api.post(`${COSTALLOCATION_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

export const saveCostAllocation = async (payload: CostAllocationType): Promise<{
  status: StatusResponse,
  data: CostAllocationType
}> => {
  const config = {
    method: payload.costAllocationId === 0 ? 'post' : 'put',
    url: COSTALLOCATION_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: CostAllocationType
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};




//transporter 

export const saveTransporter = async (payload:TransporterMaster):Promise<{
    status: StatusResponse,
    data: TransporterMaster
}>  => {
const config = {
    method: payload.transporterId === 0 ? 'post' : 'put',
    url: TRANSPORTER_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransporterMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}




export const getTransporterMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: TransporterMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransporterMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${TRANSPORTER_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${TRANSPORTER_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getTransporterById = async (transporterId:number):Promise<
{
    status: StatusResponse, 
    data: TransporterMaster
}> => {
const config = {
    method: 'get',
    url: `${TRANSPORTER_MASTER}/${transporterId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: TransporterMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


export const saveSupplier = async (payload:SupplierMaster):Promise<{
    status: StatusResponse,
    data: SupplierMaster
}>  => {
const config = {
    method: payload.supplierId === 0 ? 'post' : 'put',
    url: SUPPLIER_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: SupplierMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}




export const getSupplierMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
    status: StatusResponse,
    data: SupplierMaster[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page, offSet: page,
        filters: filter
    }
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: SupplierMaster[],
        pagination: PaginationResponse
    //}> = await Api.get(`${SUPPLIER_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${SUPPLIER_MASTER}/filter`,payload);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}

export const getSupplierById = async (supplierId:number):Promise<
{
    status: StatusResponse, 
    data: SupplierMaster
}> => {
const config = {
    method: 'get',
    url: `${SUPPLIER_MASTER}/${supplierId}`
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: SupplierMaster
    }> = await Api(config);
    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}



// insurance currency
export const getCategoryById = async (categoryId:number):Promise<
    {
        status: StatusResponse, 
        data: CategoryMaster
    }> => {
    const config = {
        method: 'get',
        url: `${CATEGORY_MASTER}/${categoryId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CategoryMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}


export const getCategoryAssetMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: CategoryMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
        limit: rows,
        page: page, offSet: page,
       
        filters: filter
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: CategoryMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${CATEGORY_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${CATEGORY_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveAssetCategory = async (payload:CategoryMaster):Promise<{
    status: StatusResponse,
    data: CategoryMaster
}>  => {
const config = {
    method: payload.categoryId === 0 ? 'post' : 'put',
    url: CATEGORY_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: CategoryMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}


export const saveServiceType = async (payload: ServiceTypeType): Promise<{
  status: StatusResponse,
  data: ServiceTypeType
}> => {
  const config = {
    method: payload.serviceTypeId === 0 ? 'post' : 'put',
    url: SERVICETYPE_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ServiceTypeType
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


export const getServiceTypeById = async (modelId: number): Promise<{
  status: StatusResponse,
  data: ServiceTypeType
}> => {
  const config = {
    method: 'get',
    url: `${SERVICETYPE_MASTER}/${modelId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: ServiceTypeType
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getServiceTypeList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: ServiceTypeType[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: ServiceTypeType[],
        pagination: PaginationResponse
      }> = await Api.post(`${SERVICETYPE_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };




export const saveInspectionType = async (payload: InspectionTypeType): Promise<{
  status: StatusResponse,
  data: InspectionTypeType
}> => {
  const config = {
    method: payload.inspectionTypeId === 0 ? 'post' : 'put',
    url: INSPECTIONTYPE_MASTER,
    data: payload
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: InspectionTypeType
    }> = await Api(config);

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};


export const getInspectionTypeById = async (modelId: number): Promise<{
  status: StatusResponse,
  data: InspectionTypeType
}> => {
  const config = {
    method: 'get',
    url: `${INSPECTIONTYPE_MASTER}/${modelId}`
  };
  try {
    const response: AxiosResponse<{
      status: StatusResponse,
      data: InspectionTypeType
    }> = await Api(config);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};

export const getInspectionTypeList =
  async (page: number, rows: number, filter: Record<string, any>): Promise<{
    status: StatusResponse,
    data: InspectionTypeType[],
    pagination: PaginationResponse
  }> => {
    const payload = {
      limit: rows,
      page: page, offSet: page,
      filters: filter
    };
    try {
      const response: AxiosResponse<{
        status: StatusResponse,
        data: InspectionTypeType[],
        pagination: PaginationResponse
      }> = await Api.post(`${INSPECTIONTYPE_MASTER}/filter`, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

export const getBackChargeById = async (backChargeId:number):Promise<
    {
        status: StatusResponse, 
        data: BackchargeMaster
    }> => {
    const config = {
        method: 'get',
        url: `${BACKCHARGE_MASTER}/${backChargeId}`
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: BackchargeMaster
        }> = await Api(config);
        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const getBackChargeMasterDataList = 
async(page:number, rows:number, filter: Record<string, any>):Promise<{
        status: StatusResponse,
        data: BackchargeMaster[],
        pagination: PaginationResponse
    }> => {
        const payload = {
        limit: rows,
        page: page, offSet: page,
       
        filters: filter
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: BackchargeMaster[],
            pagination: PaginationResponse
        //}> = await Api.get(`${CURRENCY_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${BACKCHARGE_MASTER}`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const saveBackcharge = async (payload:BackchargeMaster):Promise<{
    status: StatusResponse,
    data: BackchargeMaster
}>  => {
const config = {
    method: payload.backChargeId === 0 ? 'post' : 'put',
    url: BACKCHARGE_MASTER,
    data: payload
}
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: BackchargeMaster
    }> = await Api(config);

    if(response.status === 200 || response.status === 201){
        return response.data;
    }else{
        throw new Error(`Request failed with status code:${response.status}`);
    }
}catch(error){
    throw error;
}
}





















